import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDISfaNkS5tVUtuwgXnvh5dnVyNucw_qvs",
  authDomain: "auth.rockcola.club",
  projectId: "queuebar-842e7",
  storageBucket: "queuebar-842e7.firebasestorage.app",
  messagingSenderId: "42916016904",
  appId: "1:42916016904:web:903e123b087bb3dfe3b2bd",
  measurementId: "G-DHF4C5GL84"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
setPersistence(auth, browserLocalPersistence).catch(() => {});